import request from "@/utils/request";

const scope = '/api';
// 扫码-微信授权
export function getAccessToken(query){
    return request({
        url: scope + "/exueyun-client-consumer/h5/pay/wechat/getAccessToken",
        method: "get",
        params: query
    })
}

//5、扫码-根据订单id查询订单状态

export function getOrderStatus(query){
    return request({
        url: scope + "/exueyun-client-consumer/h5/pay/getOrderStatus",
        method: "get",
        params: query
    })
}

//4、扫码唤起支付
export function payArouse(query) {
    return request({
        url: scope + "/exueyun-client-consumer/h5/pay/arouse",
        method: "post",
        data: query
    })
}

//3、扫码创建订单
export function payCreate(query) {
    return request({
        url: scope + "/exueyun-client-consumer/h5/pay/create",
        method: "post",
        data: query
    })
}


//2、扫码-提供学校查询收费设置列表
export function listChargeConfigBySchoolId(query) {
    return request({
        url: scope + "/exueyun-client-consumer/h5/pay/listChargeConfigBySchoolId",
        method: "post",
        data: query
    })
}

// 1、根据学校Id获取学校班级信息
export function getBaseInfoBySchoolId(query) {
    return request({
        url: scope + "/exueyun-client-consumer/outline/getBaseInfoBySchoolId",
        method: "post",
        data: query,
        // headers: {
        //     Authorization: token
        // }
    });
}

